import request from "@/utils/request";

export function getRedpackList(type) {
  return request({
    url: "/product/red-packet/my/redPacket/" + type,
    method: "get",
  });
}
export function getMyCoupon(params) {
  return request({
    url: "/product/coupon/my",
    method: "get",
    params,
  });
}
export function getFollowingActs() {
  return request({
    url: "/product/participate/collect/list",
    method: "get",
  });
}

export function getFollowingBrands() {
  return request({
    url: "/product/brand/collect/list",
    method: "get",
  });
}
export function getStoreData() {
  return request({
    url: "/trade/order/store-data",
    method: "get",
  });
}

// 获取我喜欢的发现文字
export function getDiscoveryLike() {
  return request({
    url: "/setting/fodder/h5/collect/like",
    method: "get",
  });
}

export function getOrderNumber(params) {
  return request({
    url: "/trade/order/order/states-number",
    method: "get",
    params,
  });
}

export function getGoodsRecordNum() {
  return request({
    url: "/product/access-log/goods/page-view",
    method: "get",
  });
}
